import { AppChooserDialogState } from './app-chooser-dialog.state';

/**
 * Initialer State für den App-Chooser-Dialog.
 */
export const appChooserDialogStateInitial: AppChooserDialogState = {
  isOpen: false,
  intentConfig: undefined,
  appConfigs: [],
};
